<div class="container">

  <app-header-dialog [iconName]="'email_outline'">
    {{letter.name}}
  </app-header-dialog>

  <div class='tab-content'>

    <mat-card>

      <div style="display: flex; flex-direction: row; justify-content: space-between;">

        <span>
          <a *ngIf='invite.url_back' style="color:black;" target='_blank' href={{invite.url_back}}>
            {{ invite.member_name }}
          </a>
          <span *ngIf='!invite.url_back'>
            {{ invite.member_name }}
          </span>
        </span>

        <span>
          <span *ngIf='letter.type=="0"'>Carta de Confirmação</span>
          <span *ngIf='letter.type=="1"'>Carta de Atualização</span>
          <span *ngIf='letter.type=="2"'>Carta de Agendamento</span>
        </span>

        <span>
          <span *ngIf="invite.date_sent">
            <span> {{invite.date_sent | date: 'dd/MM/yyyy'}}</span>
          </span>

          <span *ngIf="invite.date_response">
            -<span style="color: blue;">{{invite.date_response | date: 'dd/MM/yyyy'}}</span>
          </span>
        </span>

        <span *ngIf="!invite.date_sent">
          <button class="flat-button" mat-dialog-close (click)="matDialogRef.close(['invite', invite ])">
            Convidar sem e-mail
          </button>
        </span>

        <span *ngIf="letter.type=='0' && invite.date_sent && !invite.date_response">
          <button class="flat-button" mat-dialog-close (click)="matDialogRef.close(['response', invite ])">
            Registrar confirmações
          </button>
        </span>

      </div>

    </mat-card>


    <mat-card>
      <div style='height: 530px; overflow: auto;'>

        <div
          style="height: 20px; border-radius: 5px; margin-bottom: 5px;  padding: 3px 3px 3px 5px; background-color: rgb(243, 239, 239);">
          <div *ngIf='invite.admin_invite'>
            Convite via admin
          </div>
          <div *ngIf='invite.admin_response'>
            Resposta via admin
          </div>
          <div *ngIf='invite.obs'>
            {{invite.obs}}
          </div>
        </div>

        <div *ngFor="let appointment of invite.agenda">

          <div
            style="padding: 10px; margin-bottom: 40px;  background-color: rgba(209, 229, 236, .3); border-radius: 10px;">

            <div class="tarja">
              <div>
                <span>{{appointment.role_name}}</span>
                <span *ngIf="appointment.level=='t'"> no tópico</span>
                <span *ngIf="appointment.level=='a'"> na atividade</span>
              </div>
              <mat-checkbox [(ngModel)]="appointment.acceptInvite" color='primary'
                *ngIf="invite.date_sent && !invite.date_response">
                Confirmar
              </mat-checkbox>
              <div *ngIf="invite.date_sent && invite.date_response">
                <div *ngIf="appointment.acceptInvite">
                  <img style='width: 10px;' src="assets/images/status/img_green.png">
                </div>
                <div *ngIf="!appointment.acceptInvite">
                  <img style='width: 10px;' src="assets/images/status/img_red.png">
                </div>
              </div>
            </div>

            <ul style="margin-top: 0;">
              <li>
                {{appointment.day_date.seconds*1000 | date: 'dd/MM/yyyy'}}
              </li>
              <li>
                <span>Depto:&nbsp;</span>
                <span>{{appointment.depto_name}}</span>
              </li>
              <li>
                <div class='line-display'>
                  <span>Atividade:&nbsp;</span>
                  <span *ngIf="appointment.requireConfirm" style="color: green;">(Confirmar)</span>
                  <span *ngIf="!appointment.requireConfirm" style="color: red;">(Não confirmar)</span>
                </div>
                <div>
                  {{appointment.activity_startTime}} -
                  {{appointment.activity_name}}
                </div>
              </li>

              <div *ngIf="appointment.level=='t'">
                <li>
                  <div class='line-display'>Tópico: </div>
                  {{appointment.topic_startTime}} -
                  {{appointment.topic_name}}
                </li>
                <li>
                  <div class='line-display'>Duração: </div>
                  {{appointment.topic_duration}} minutos
                </li>
                <li>
                  <div>Equipe do Tópico</div>
                  <ul *ngFor="let st of appointment.topicStaff">
                    <li>
                      <div>{{st.role_name}} - {{st.member_name}}</div>
                    </li>
                  </ul>
                </li>

              </div>

              <div *ngIf="appointment.level=='a'">

                <li>
                  <div>Equipe da atividade</div>
                  <ul *ngFor="let st of appointment.activityStaff">
                    <li>
                      <div>{{st.role_name}} - {{st.member_name}}</div>
                    </li>
                  </ul>
                </li>
                <li>
                  <div>Tópico(s)</div>
                  <ul *ngFor="let ac of appointment.activityTopics">
                    <li>
                      <div>{{ac.topic_startTime}} - {{ac.topic_name}}</div>
                    </li>
                  </ul>
                </li>

              </div>

            </ul>

          </div>

        </div>

      </div>

    </mat-card>

  </div>

</div>